@if (showVideoPlayer()) {
  <iframe
    [src]="videoUrl()"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    allowfullscreen
    class="size-full"
    title="YouTube video player iframe">
  </iframe>
} @else {
  <div (click)="onPlaceholderClick()" class="relative aspect-video cursor-pointer bg-black">
    <img
      (load)="onThumbnailLoad($event)"
      [src]="videoImgUrl()"
      alt="YouTube video thumbnail"
      class="absolute inset-0 size-full object-cover" />
    <div class="absolute inset-0 z-20 flex cursor-pointer items-center justify-center">
      <app-svg [hasShadowCta]="true" [height]="58" [width]="58" src="assets/icons/player.svg" />
    </div>
  </div>
}
